export const STATSIG_FEATURE_GATES = {
  ENABLE_INTERCOM_MESSENGER: 'enable_intercom_messenger',
  ENABLE_BILLING_PROFILE_LINK: 'enable_billing_profile_link',
  ENABLE_ADD_ONS: 'enable_add_ons',
  ENABLE_SUBSCRIPTIONS_RENEWAL_DATE_FILTER: 'enable_subscription_renewal_date_filter',
  ENABLE_SANDBOX_SUPPORT_FOR_SUBSCRIPTIONS: 'enable_sandbox_support_for_subscriptions',
  ENABLE_MANAGE_SUBSCRIPTION_OMS_V2: 'enable_manage_subscription_oms_v2',
  ENABLE_STANDALONE_LOOM_FOR_UOF: 'enable_standalone_loom_for_uof',
  ENABLE_PREVENT_NON_COMMERCIAL_BILLING_PROFILES: 'enable_prevent_non_commercial_billing_profiles',
  // show the  disabled entitlements on the sidebar of the UOF for annual and status as inactive
  ENABLE_INACTIVE_PRODUCTS_IN_UOF: 'enable_inactive_products_in_uof',
  ENABLE_NOTIFICATION_AT_BILLING_PROFILE: 'enable_notification_at_billing_profile',
  ENABLE_HIDE_BILLING_ADMINS: 'enable_hide_billing_admins_with_specific_domains',
  ENABLE_LOOM_OVERAGE: 'enable_loom_overage',
  ENABLE_LOOM_SUPPORT: 'enable_loom_support',
  ENABLE_PARTNER_MARGIN_COLUMN_FOR_ANY_BILLING_CYCLE: 'enable_partner_margin_column_for_any_billing_cycle',
  ENABLE_ROVO_IN_PPC_PHASE2: 'enable_rovo_in_ppc_phase_2',
  ENABLE_JSM_OFFERING_CHANGE: 'enable_jsm_standard_offering_change',
  ENABLE_WILDCARD_BILLING_PROFILE_SEARCH_HYDRA: 'enable_wildcard_billing_profile_search_hydra',
  ENABLE_COMPASS_PREMIUM: 'enable_compass_premium',
  ENABLE_STEP_UP_CREDIT_SUPPORT: 'enable_step_up_credit_support',
  ENABLE_OFFERINGS_EXCLUDE_WITHOUT_IDS: 'enable_offerings_exclude_without_ids',
  ENABLE_ENTITLEMENT_FETCH_IN_CHUNKS_ON_UOF: 'enable_entitlements_fetch_in_chunks_on_uof',
  ENABLE_DESIGN_ITERATION_1: 'enable_design_iteration_1',
  ENABLE_ORG_BASED_SEARCH_FOR_SOLD_TO_ADDRESS: 'enable_org_based_search_for_sold_to_address',
  ENABLE_BILLING_PROFILE_SWITCH_ON_SAME_PRICING_PLAN: 'enable_billing_profile_switch_on_same_pricing_plan',
  // ENABLE_ACCESS_PPC = If false, shows an under maintenance page
  ENABLE_PPC_ACCESS: 'enable_ppc_access',
  ENABLE_SANDBOX_DECOUPLING: 'enable_sandbox_decoupling',
  ENABLE_GRAPHQL_CACHING: 'enable_graphql_caching',
  ENABLE_NON_COMMERCIAL_PRICING: 'enable_non-commercial_pricing',
  ENABLE_MULTI_CURRENCY_CHANGES: 'enable_jpy_changes',
  ENABLE_SUPPORT_FOR_FUTURE_DATED_ENTITLEMENTS: 'enable_support_for_future_dated_entitlements',
  ENABLE_CUSTOMER_CONTACT_V3: 'enable_customer_contact_v3',
  ENABLE_EXPERIMENTAL_PRODUCTS_IN_CATALOG: 'enable_experimental_products_in_catalogue',
  ENABLE_SANDBOX_APP_CREATE_IN_UOF: 'enable_sandbox_app_create_in_uof',
  ENABLE_NEW_CHANGE_BILLING_PROFILE_BEHAVIOUR: 'enable_new_change_billing_profile_behaviour',
  ENABLE_BILLING_PROFILE_SEARCH: 'enable_billing_profile_search',
  ENABLE_USE_GET_AGGREGATE_CCP_LIST_HOOK: 'enable-use-get-aggregate-ccp-list-hook',
  ENABLE_FLAT_DISCOUNT_SUPPORT: 'enable_flat_discount_support',
  ENABLE_EXPOSE_AND_SEARCH_BY_BILLING_PROFILE_ID: 'enable_expose_and_search_by_billing_profile_id',
  ENABLE_REACT_SSR_MVP: 'enable_react_ssr_mvp',
  ENABLE_POST_OFFICE_NOTIFICATIONS: 'enable_post_office_notifications',
  ENABLE_PAYPAL_SUPPORT: 'enable_paypal_support',
  ENABLE_CREDIT_CALCULATION_IN_QUOTE: 'enable_credit_calculation_in_quote',
  ENABLE_EMAILS_IMPROVEMENT: 'enable_emails_improvement', // a similar FF (ac_enable_emails_improvement) is also added on the ANS side, please make sure to keep these in sync.
  ENABLE_SFDC_DATA_CACHING_FOR_PARTNER_PROFILE: 'enable_sfdc_data_caching_for_partner_profile',
  ENABLE_PREMIUM_ANNUAL_TRIAL_IN_PPC: 'enable_premium_annual_trial',
  ENABLE_JPD_PREMIUM_OFFERING: 'enable_jpd_premium',
  ENABLE_INTERNAL_USAGE_LICENSES_SUPPORT: 'enable_internal_usage_licenses_support',
  ENABLE_JPD_AS_JIRA_FAMILY: 'enable_jpd_as_jira_family',
  ENABLE_CO_TERM_IN_UOF: 'enable_co_term_in_uof',
  ENABLE_BILLING_PROFILE_FROM_CCP: 'enable_billing_profile_from_ccp',
  ENABLE_TWC_SUPPORT_PHASE_1: 'enable_twc_support',
  ENABLE_TWC_SUPPORT_PHASE_2: 'enable_twc_support_phase_2',
  ENABLE_QUOTE_V2: 'enable_quote_v2',
  DISABLE_BP_ARCHIVAL: 'disable_billing_profile_archival',
  ENABLE_ADD_ONS_PHASE_V2: 'enable_add_ons_phase_2',
  ENABLE_STATUSPAGE: 'enable_statuspage',
  ENABLE_STRATEGY_COLLECTION: 'enable_strategy_collection',
  ENABLE_EXCLUDE_EXPIRED_PROMOTIONS_IN_UOF: 'enable_exclude_expired_promotions_in_uof',
  ENABLE_APP_EDITION_SUPPORT: 'enable_app_edition_support',
  ENABLE_ARCHIVE_SOLD_TO_ADDRESS: 'enable_archive_sold_to_address',
  ENABLE_GRACE_PERIOD_VISIBILITY: 'enable_grace_period_visibility',
  ENABLE_DEFAULT_FILTERS: 'enable_default_filters',
  ENABLE_IUL_PHASE_2: 'enable_iul_phase_2',
  ENABLE_APPIFICATION: 'enable_appification',
  ENABLE_IUL_BALANCE_DATA_USAGE_VIA_AUTH: 'enable_iul_balance_data_usage_via_auth',
  ENABLE_MULTI_INSTANCE_APPS: 'enable_multi_instance_apps',
  ENABLE_DUPLICATE_CUSTOMER_NAME: 'enable_duplicate_customer_name',
  ENABLE_RESTRICT_ROVO_AMENDMENTS: 'enable_restrict_rovo',
  ENABLE_SELF_SERVE_QUOTING: 'enable_self_serve_quoting',
  ENABLE_DEAL_REGISTRATIONS: 'enable_deal_registrations',
  ENABLE_HWB_UPGRADE: 'enable_hwb_upgrade',
  ENABLE_EMAIL_PROP_INTERCOM: 'enable_email_prop_intercom',
  ENABLE_REDESIGN_FAST_FOLLOW: 'enable_redesign_fast_follow',
  ENABLE_ACH_DIRECT_DEBIT: 'enable_ach_direct_debit',
  ENABLE_EDIT_ECC: 'enable_edit_ecc',
  ENABLE_FETCH_BILLING_USER_BY_ORG: 'enable_fetch_billing_user_by_org',
  ENABLE_CHANNEL_ROLE_ACCESS: 'enable_channel_role_access',
} as const;

export const STATSIG_FEATURE_GATES_LOCAL_VALUE: Record<string, boolean> = {
  [STATSIG_FEATURE_GATES.ENABLE_INTERCOM_MESSENGER]: true,
  [STATSIG_FEATURE_GATES.ENABLE_BILLING_PROFILE_LINK]: true,
  [STATSIG_FEATURE_GATES.ENABLE_ADD_ONS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_SUBSCRIPTIONS_RENEWAL_DATE_FILTER]: true,
  [STATSIG_FEATURE_GATES.ENABLE_SANDBOX_SUPPORT_FOR_SUBSCRIPTIONS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_PREVENT_NON_COMMERCIAL_BILLING_PROFILES]: false,
  [STATSIG_FEATURE_GATES.ENABLE_MANAGE_SUBSCRIPTION_OMS_V2]: true,
  [STATSIG_FEATURE_GATES.ENABLE_STANDALONE_LOOM_FOR_UOF]: false,
  [STATSIG_FEATURE_GATES.ENABLE_INACTIVE_PRODUCTS_IN_UOF]: true,
  [STATSIG_FEATURE_GATES.ENABLE_NOTIFICATION_AT_BILLING_PROFILE]: false, // intentionally set to false as integration tests were failing.
  [STATSIG_FEATURE_GATES.ENABLE_HIDE_BILLING_ADMINS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_LOOM_OVERAGE]: true,
  [STATSIG_FEATURE_GATES.ENABLE_LOOM_SUPPORT]: true,
  [STATSIG_FEATURE_GATES.ENABLE_SANDBOX_APP_CREATE_IN_UOF]: true,
  [STATSIG_FEATURE_GATES.ENABLE_PARTNER_MARGIN_COLUMN_FOR_ANY_BILLING_CYCLE]: true,
  [STATSIG_FEATURE_GATES.ENABLE_JSM_OFFERING_CHANGE]: true,
  [STATSIG_FEATURE_GATES.ENABLE_WILDCARD_BILLING_PROFILE_SEARCH_HYDRA]: true,
  [STATSIG_FEATURE_GATES.ENABLE_COMPASS_PREMIUM]: true,
  [STATSIG_FEATURE_GATES.ENABLE_STEP_UP_CREDIT_SUPPORT]: true,
  [STATSIG_FEATURE_GATES.ENABLE_OFFERINGS_EXCLUDE_WITHOUT_IDS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_ENTITLEMENT_FETCH_IN_CHUNKS_ON_UOF]: true,
  [STATSIG_FEATURE_GATES.ENABLE_BILLING_PROFILE_SWITCH_ON_SAME_PRICING_PLAN]: true,
  [STATSIG_FEATURE_GATES.ENABLE_PPC_ACCESS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_SANDBOX_DECOUPLING]: true,
  [STATSIG_FEATURE_GATES.ENABLE_GRAPHQL_CACHING]: true,
  [STATSIG_FEATURE_GATES.ENABLE_MULTI_CURRENCY_CHANGES]: false, // will enable it once integration test is added for this flow
  [STATSIG_FEATURE_GATES.ENABLE_NON_COMMERCIAL_PRICING]: true,
  [STATSIG_FEATURE_GATES.ENABLE_SUPPORT_FOR_FUTURE_DATED_ENTITLEMENTS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_CUSTOMER_CONTACT_V3]: true,
  [STATSIG_FEATURE_GATES.ENABLE_EXPERIMENTAL_PRODUCTS_IN_CATALOG]: true,
  [STATSIG_FEATURE_GATES.ENABLE_NEW_CHANGE_BILLING_PROFILE_BEHAVIOUR]: true,
  [STATSIG_FEATURE_GATES.ENABLE_BILLING_PROFILE_SEARCH]: true,
  [STATSIG_FEATURE_GATES.ENABLE_USE_GET_AGGREGATE_CCP_LIST_HOOK]: true,
  [STATSIG_FEATURE_GATES.ENABLE_FLAT_DISCOUNT_SUPPORT]: true,
  [STATSIG_FEATURE_GATES.ENABLE_EXPOSE_AND_SEARCH_BY_BILLING_PROFILE_ID]: true,
  [STATSIG_FEATURE_GATES.ENABLE_REACT_SSR_MVP]: false,
  [STATSIG_FEATURE_GATES.ENABLE_POST_OFFICE_NOTIFICATIONS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_ORG_BASED_SEARCH_FOR_SOLD_TO_ADDRESS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_PAYPAL_SUPPORT]: true,
  [STATSIG_FEATURE_GATES.ENABLE_CREDIT_CALCULATION_IN_QUOTE]: true,
  [STATSIG_FEATURE_GATES.ENABLE_EMAILS_IMPROVEMENT]: true,
  [STATSIG_FEATURE_GATES.ENABLE_SFDC_DATA_CACHING_FOR_PARTNER_PROFILE]: true,
  [STATSIG_FEATURE_GATES.ENABLE_PREMIUM_ANNUAL_TRIAL_IN_PPC]: true,
  [STATSIG_FEATURE_GATES.ENABLE_JPD_PREMIUM_OFFERING]: true,
  [STATSIG_FEATURE_GATES.ENABLE_INTERNAL_USAGE_LICENSES_SUPPORT]: true,
  [STATSIG_FEATURE_GATES.ENABLE_JPD_AS_JIRA_FAMILY]: false,
  [STATSIG_FEATURE_GATES.ENABLE_CO_TERM_IN_UOF]: true,
  [STATSIG_FEATURE_GATES.ENABLE_BILLING_PROFILE_FROM_CCP]: false, // https://hello.jira.atlassian.cloud/browse/ITFO-24877
  [STATSIG_FEATURE_GATES.ENABLE_TWC_SUPPORT_PHASE_1]: true,
  [STATSIG_FEATURE_GATES.ENABLE_TWC_SUPPORT_PHASE_2]: true,
  [STATSIG_FEATURE_GATES.ENABLE_QUOTE_V2]: true,
  [STATSIG_FEATURE_GATES.ENABLE_ROVO_IN_PPC_PHASE2]: true,
  [STATSIG_FEATURE_GATES.DISABLE_BP_ARCHIVAL]: false,
  [STATSIG_FEATURE_GATES.ENABLE_ADD_ONS_PHASE_V2]: true,
  [STATSIG_FEATURE_GATES.ENABLE_STATUSPAGE]: false,
  [STATSIG_FEATURE_GATES.ENABLE_STRATEGY_COLLECTION]: true,
  [STATSIG_FEATURE_GATES.ENABLE_EXCLUDE_EXPIRED_PROMOTIONS_IN_UOF]: true,
  [STATSIG_FEATURE_GATES.ENABLE_APP_EDITION_SUPPORT]: true,
  [STATSIG_FEATURE_GATES.ENABLE_ARCHIVE_SOLD_TO_ADDRESS]: false,
  [STATSIG_FEATURE_GATES.ENABLE_GRACE_PERIOD_VISIBILITY]: true,
  [STATSIG_FEATURE_GATES.ENABLE_DEFAULT_FILTERS]: false,
  [STATSIG_FEATURE_GATES.ENABLE_IUL_PHASE_2]: true,
  [STATSIG_FEATURE_GATES.ENABLE_APPIFICATION]: true,
  [STATSIG_FEATURE_GATES.ENABLE_IUL_BALANCE_DATA_USAGE_VIA_AUTH]: false,
  [STATSIG_FEATURE_GATES.ENABLE_MULTI_INSTANCE_APPS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_DUPLICATE_CUSTOMER_NAME]: true,
  [STATSIG_FEATURE_GATES.ENABLE_RESTRICT_ROVO_AMENDMENTS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_DEAL_REGISTRATIONS]: true,
  [STATSIG_FEATURE_GATES.ENABLE_HWB_UPGRADE]: false, //Enable it after updating integration test for entitlement details page
  [STATSIG_FEATURE_GATES.ENABLE_EMAIL_PROP_INTERCOM]: true,
  [STATSIG_FEATURE_GATES.ENABLE_SELF_SERVE_QUOTING]: false,
  [STATSIG_FEATURE_GATES.ENABLE_DESIGN_ITERATION_1]: false,
  [STATSIG_FEATURE_GATES.ENABLE_REDESIGN_FAST_FOLLOW]: false,
  [STATSIG_FEATURE_GATES.ENABLE_ACH_DIRECT_DEBIT]: false,
  [STATSIG_FEATURE_GATES.ENABLE_EDIT_ECC]: true,
  [STATSIG_FEATURE_GATES.ENABLE_FETCH_BILLING_USER_BY_ORG]: true,
  [STATSIG_FEATURE_GATES.ENABLE_CHANNEL_ROLE_ACCESS]: true,
};
